/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Api Documentation
 * Api Documentation
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  GetV7SqlserverSearchSqlByIntervalParams,
  GetV7SqlserverSqlByIntervalParams,
  GetV7SqlserverSqlListByIntervalParams,
  GetV7SqlserverSqlShortListParams,
  GetV7SqlserverSqlShortViewParams,
  GetV7SqlserverSqlStatListParams,
  GetV7SqlserverSqlSummaryListParams,
  GetV7SqlserverSqlTextParams,
  GetV7SqlserverTopSqlParams,
  SqlByIntervalV7Response,
  SqlIntervalSearchResponse,
  SqlListByIntervalResponse,
  SqlShortListV7Response,
  SqlShortViewsV7Response,
  SqlStatListV7Response,
  SqlSummaryListResponse,
  SqlTextV7Response,
  TopSqlV7Response,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary sqlByIntervalSearch
 */
export const getV7SqlserverSearchSqlByInterval = (
  params: MaybeRef<GetV7SqlserverSearchSqlByIntervalParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlIntervalSearchResponse>(
    {
      url: `/api/v7/sqlserver/search/sql-by-interval`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7SqlserverSearchSqlByIntervalQueryKey = (
  params?: MaybeRef<GetV7SqlserverSearchSqlByIntervalParams>,
) => {
  return [
    'api',
    'v7',
    'sqlserver',
    'search',
    'sql-by-interval',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7SqlserverSearchSqlByIntervalQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7SqlserverSearchSqlByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7SqlserverSearchSqlByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7SqlserverSearchSqlByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7SqlserverSearchSqlByIntervalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7SqlserverSearchSqlByInterval>>> = ({
    signal,
  }) => getV7SqlserverSearchSqlByInterval(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7SqlserverSearchSqlByInterval>>,
    TError,
    TData
  >;
};

export type GetV7SqlserverSearchSqlByIntervalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7SqlserverSearchSqlByInterval>>
>;
export type GetV7SqlserverSearchSqlByIntervalQueryError = ErrorType<unknown>;

/**
 * @summary sqlByIntervalSearch
 */

export function useGetV7SqlserverSearchSqlByInterval<
  TData = Awaited<ReturnType<typeof getV7SqlserverSearchSqlByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7SqlserverSearchSqlByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7SqlserverSearchSqlByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7SqlserverSearchSqlByIntervalQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary sqlByInterval
 */
export const getV7SqlserverSqlByInterval = (
  params: MaybeRef<GetV7SqlserverSqlByIntervalParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlByIntervalV7Response>(
    { url: `/api/v7/sqlserver/sql-by-interval`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7SqlserverSqlByIntervalQueryKey = (
  params?: MaybeRef<GetV7SqlserverSqlByIntervalParams>,
) => {
  return ['api', 'v7', 'sqlserver', 'sql-by-interval', ...(params ? [params] : [])] as const;
};

export const getGetV7SqlserverSqlByIntervalQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7SqlserverSqlByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7SqlserverSqlByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7SqlserverSqlByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7SqlserverSqlByIntervalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7SqlserverSqlByInterval>>> = ({
    signal,
  }) => getV7SqlserverSqlByInterval(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7SqlserverSqlByInterval>>,
    TError,
    TData
  >;
};

export type GetV7SqlserverSqlByIntervalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7SqlserverSqlByInterval>>
>;
export type GetV7SqlserverSqlByIntervalQueryError = ErrorType<unknown>;

/**
 * @summary sqlByInterval
 */

export function useGetV7SqlserverSqlByInterval<
  TData = Awaited<ReturnType<typeof getV7SqlserverSqlByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7SqlserverSqlByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7SqlserverSqlByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7SqlserverSqlByIntervalQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary sqlListByInterval
 */
export const getV7SqlserverSqlListByInterval = (
  params: MaybeRef<GetV7SqlserverSqlListByIntervalParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlListByIntervalResponse>(
    { url: `/api/v7/sqlserver/sql-list-by-interval`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7SqlserverSqlListByIntervalQueryKey = (
  params?: MaybeRef<GetV7SqlserverSqlListByIntervalParams>,
) => {
  return ['api', 'v7', 'sqlserver', 'sql-list-by-interval', ...(params ? [params] : [])] as const;
};

export const getGetV7SqlserverSqlListByIntervalQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7SqlserverSqlListByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7SqlserverSqlListByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7SqlserverSqlListByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7SqlserverSqlListByIntervalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7SqlserverSqlListByInterval>>> = ({
    signal,
  }) => getV7SqlserverSqlListByInterval(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7SqlserverSqlListByInterval>>,
    TError,
    TData
  >;
};

export type GetV7SqlserverSqlListByIntervalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7SqlserverSqlListByInterval>>
>;
export type GetV7SqlserverSqlListByIntervalQueryError = ErrorType<unknown>;

/**
 * @summary sqlListByInterval
 */

export function useGetV7SqlserverSqlListByInterval<
  TData = Awaited<ReturnType<typeof getV7SqlserverSqlListByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7SqlserverSqlListByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7SqlserverSqlListByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7SqlserverSqlListByIntervalQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 싱글뷰 > SQL Elapsed Time 스캐터 차트: 드래그시 SQL Stat List 팝업 API
 */
export const getV7SqlserverSqlShortList = (
  params: MaybeRef<GetV7SqlserverSqlShortListParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlShortListV7Response>(
    { url: `/api/v7/sqlserver/sql-short-list`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7SqlserverSqlShortListQueryKey = (
  params?: MaybeRef<GetV7SqlserverSqlShortListParams>,
) => {
  return ['api', 'v7', 'sqlserver', 'sql-short-list', ...(params ? [params] : [])] as const;
};

export const getGetV7SqlserverSqlShortListQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7SqlserverSqlShortList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7SqlserverSqlShortListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7SqlserverSqlShortList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7SqlserverSqlShortListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7SqlserverSqlShortList>>> = ({
    signal,
  }) => getV7SqlserverSqlShortList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7SqlserverSqlShortList>>,
    TError,
    TData
  >;
};

export type GetV7SqlserverSqlShortListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7SqlserverSqlShortList>>
>;
export type GetV7SqlserverSqlShortListQueryError = ErrorType<unknown>;

/**
 * @summary 싱글뷰 > SQL Elapsed Time 스캐터 차트: 드래그시 SQL Stat List 팝업 API
 */

export function useGetV7SqlserverSqlShortList<
  TData = Awaited<ReturnType<typeof getV7SqlserverSqlShortList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7SqlserverSqlShortListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7SqlserverSqlShortList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7SqlserverSqlShortListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 싱글뷰 > SQL Elapsed Time 스캐터 차트 API
 */
export const getV7SqlserverSqlShortView = (
  params: MaybeRef<GetV7SqlserverSqlShortViewParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlShortViewsV7Response>(
    { url: `/api/v7/sqlserver/sql-short-view`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7SqlserverSqlShortViewQueryKey = (
  params?: MaybeRef<GetV7SqlserverSqlShortViewParams>,
) => {
  return ['api', 'v7', 'sqlserver', 'sql-short-view', ...(params ? [params] : [])] as const;
};

export const getGetV7SqlserverSqlShortViewQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7SqlserverSqlShortView>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7SqlserverSqlShortViewParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7SqlserverSqlShortView>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7SqlserverSqlShortViewQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7SqlserverSqlShortView>>> = ({
    signal,
  }) => getV7SqlserverSqlShortView(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7SqlserverSqlShortView>>,
    TError,
    TData
  >;
};

export type GetV7SqlserverSqlShortViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7SqlserverSqlShortView>>
>;
export type GetV7SqlserverSqlShortViewQueryError = ErrorType<unknown>;

/**
 * @summary 싱글뷰 > SQL Elapsed Time 스캐터 차트 API
 */

export function useGetV7SqlserverSqlShortView<
  TData = Awaited<ReturnType<typeof getV7SqlserverSqlShortView>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7SqlserverSqlShortViewParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7SqlserverSqlShortView>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7SqlserverSqlShortViewQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary [SQL Server] 인스턴스디테일: SQL List 탭 & PA: Trend Analysis: Top SQL 탭
 */
export const getV7SqlserverSqlStatList = (
  params: MaybeRef<GetV7SqlserverSqlStatListParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlStatListV7Response>(
    { url: `/api/v7/sqlserver/sql-stat-list`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7SqlserverSqlStatListQueryKey = (
  params?: MaybeRef<GetV7SqlserverSqlStatListParams>,
) => {
  return ['api', 'v7', 'sqlserver', 'sql-stat-list', ...(params ? [params] : [])] as const;
};

export const getGetV7SqlserverSqlStatListQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7SqlserverSqlStatList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7SqlserverSqlStatListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7SqlserverSqlStatList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7SqlserverSqlStatListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7SqlserverSqlStatList>>> = ({
    signal,
  }) => getV7SqlserverSqlStatList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7SqlserverSqlStatList>>,
    TError,
    TData
  >;
};

export type GetV7SqlserverSqlStatListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7SqlserverSqlStatList>>
>;
export type GetV7SqlserverSqlStatListQueryError = ErrorType<unknown>;

/**
 * @summary [SQL Server] 인스턴스디테일: SQL List 탭 & PA: Trend Analysis: Top SQL 탭
 */

export function useGetV7SqlserverSqlStatList<
  TData = Awaited<ReturnType<typeof getV7SqlserverSqlStatList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7SqlserverSqlStatListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7SqlserverSqlStatList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7SqlserverSqlStatListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary [SQL Server] PA: Search SQL - SQL 목록 그리드 등
 */
export const getV7SqlserverSqlSummaryList = (
  params: MaybeRef<GetV7SqlserverSqlSummaryListParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlSummaryListResponse>(
    { url: `/api/v7/sqlserver/sql-summary-list`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7SqlserverSqlSummaryListQueryKey = (
  params?: MaybeRef<GetV7SqlserverSqlSummaryListParams>,
) => {
  return ['api', 'v7', 'sqlserver', 'sql-summary-list', ...(params ? [params] : [])] as const;
};

export const getGetV7SqlserverSqlSummaryListQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7SqlserverSqlSummaryList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7SqlserverSqlSummaryListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7SqlserverSqlSummaryList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7SqlserverSqlSummaryListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7SqlserverSqlSummaryList>>> = ({
    signal,
  }) => getV7SqlserverSqlSummaryList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7SqlserverSqlSummaryList>>,
    TError,
    TData
  >;
};

export type GetV7SqlserverSqlSummaryListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7SqlserverSqlSummaryList>>
>;
export type GetV7SqlserverSqlSummaryListQueryError = ErrorType<unknown>;

/**
 * @summary [SQL Server] PA: Search SQL - SQL 목록 그리드 등
 */

export function useGetV7SqlserverSqlSummaryList<
  TData = Awaited<ReturnType<typeof getV7SqlserverSqlSummaryList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7SqlserverSqlSummaryListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7SqlserverSqlSummaryList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7SqlserverSqlSummaryListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary sqlText
 */
export const getV7SqlserverSqlText = (
  params: MaybeRef<GetV7SqlserverSqlTextParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SqlTextV7Response>(
    { url: `/api/v7/sqlserver/sql-text`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7SqlserverSqlTextQueryKey = (
  params?: MaybeRef<GetV7SqlserverSqlTextParams>,
) => {
  return ['api', 'v7', 'sqlserver', 'sql-text', ...(params ? [params] : [])] as const;
};

export const getGetV7SqlserverSqlTextQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7SqlserverSqlText>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7SqlserverSqlTextParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7SqlserverSqlText>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7SqlserverSqlTextQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7SqlserverSqlText>>> = ({ signal }) =>
    getV7SqlserverSqlText(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7SqlserverSqlText>>,
    TError,
    TData
  >;
};

export type GetV7SqlserverSqlTextQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7SqlserverSqlText>>
>;
export type GetV7SqlserverSqlTextQueryError = ErrorType<unknown>;

/**
 * @summary sqlText
 */

export function useGetV7SqlserverSqlText<
  TData = Awaited<ReturnType<typeof getV7SqlserverSqlText>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7SqlserverSqlTextParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7SqlserverSqlText>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7SqlserverSqlTextQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary PA > Top N Analysis: 상위 SQL 그리드
 */
export const getV7SqlserverTopSql = (
  params: MaybeRef<GetV7SqlserverTopSqlParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<TopSqlV7Response>(
    { url: `/api/v7/sqlserver/top-sql`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7SqlserverTopSqlQueryKey = (params?: MaybeRef<GetV7SqlserverTopSqlParams>) => {
  return ['api', 'v7', 'sqlserver', 'top-sql', ...(params ? [params] : [])] as const;
};

export const getGetV7SqlserverTopSqlQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7SqlserverTopSql>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7SqlserverTopSqlParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7SqlserverTopSql>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7SqlserverTopSqlQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7SqlserverTopSql>>> = ({ signal }) =>
    getV7SqlserverTopSql(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7SqlserverTopSql>>,
    TError,
    TData
  >;
};

export type GetV7SqlserverTopSqlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7SqlserverTopSql>>
>;
export type GetV7SqlserverTopSqlQueryError = ErrorType<unknown>;

/**
 * @summary PA > Top N Analysis: 상위 SQL 그리드
 */

export function useGetV7SqlserverTopSql<
  TData = Awaited<ReturnType<typeof getV7SqlserverTopSql>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7SqlserverTopSqlParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7SqlserverTopSql>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7SqlserverTopSqlQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
